import apiRequest from "../../utils/apiRequest";

const getSingleRoleApi = async (roleId, roleType = "user") => {
    const endpoint = roleType === "admin" ? `admin/role/${roleId}` : `role/${roleId}`;
    return await apiRequest(endpoint, "get");
};

export default getSingleRoleApi;
